import {Component, OnInit} from '@angular/core';
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../api.service";

@Component({
  selector: 'app-authenticate',
  imports: [
    MatProgressSpinner
  ],
  templateUrl: './authenticate.component.html',
  styleUrl: './authenticate.component.css'
})
export class AuthenticateComponent implements OnInit {
  private token: any;

  constructor(private route: ActivatedRoute, private api: ApiService, private router: Router) {
  }

  async ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token');
    await this.api.authenticate(this.token);
    await this.api.getUserData();
    if (this.api.isLogged) this.router.navigate(['dashboard']);
  }

}
